export interface DropzoneOptions {
  dropzone: HTMLElement;
  fileInput: HTMLInputElement;
  onFile: (file: File) => void;
  onWarmupHint?: () => void;
}

export function mountDropzone({ dropzone, fileInput, onFile, onWarmupHint }: DropzoneOptions): void {
  // Give the engine a head start the moment the user shows intent — hovering
  // or focusing the drop card is enough. Cheap when engine is already loaded.
  const warm = (): void => onWarmupHint?.();
  dropzone.addEventListener('pointerenter', warm, { once: true });
  dropzone.addEventListener('focusin', warm, { once: true });

  fileInput.addEventListener('change', () => {
    const file = fileInput.files?.[0];
    if (file) onFile(file);
    fileInput.value = '';
  });

  const preventDefaults = (e: Event): void => {
    e.preventDefault();
    e.stopPropagation();
  };

  ['dragenter', 'dragover'].forEach((evt) => {
    dropzone.addEventListener(evt, (e) => {
      preventDefaults(e);
      dropzone.classList.add('dragover');
    });
  });

  ['dragleave', 'drop'].forEach((evt) => {
    dropzone.addEventListener(evt, (e) => {
      preventDefaults(e);
      dropzone.classList.remove('dragover');
    });
  });

  dropzone.addEventListener('drop', (e) => {
    const dt = (e as DragEvent).dataTransfer;
    const file = dt?.files?.[0];
    if (file) onFile(file);
  });
}
